import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Navigate, Routes, Route, useLocation, useNavigate } from 'react-router-dom';

import CODE from '../constants/code';
import URL from '../constants/url';

import axiosApi from '../api/daonAxios';
import PATH from '../constants/url';


//로그인
import AllowAccess from '../pages/user/login/AllowAccess';  // 앱 접근 권한 허용
import Landing from '../pages/user/login/Landing';  // 랜딩 페이지
import LoginMain from '../pages/user/login/LoginMain';  // 아이디 로그인 페이지

import Identity from '../pages/user/login/identity/Identity';  // 본인 확인 방법
import MobileIdentity from '../pages/user/login/identity/MobileIdentity';  // 휴대폰 본인확인
import AgreeConditions from '../pages/user/login/identity/AgreeConditions';  // 약관 동의
import AgreeGuardian from '../pages/user/login/identity/AgreeGuardian';  // 보호자 동의
import MembershipComplete from '../pages/user/login/identity/MembershipComplete';  // 회원가입 완료
import HistoryCheck from '../pages/user/login/identity/HistoryCheck';  // 가입 이력 확인
import HospitalLink from '../pages/user/login/identity/HospitalLink';  // 병원 환자번호 연동
import HospitalLinkComplete from '../pages/user/login/identity/HospitalLinkComplete';  // 병원 환자번호 연동완료

import SignUp from '../pages/user/login/membership/SignUp';  // 회원 가입
import FindId from '../pages/user/login/membership/FindId';  // 아이디 찾기
import FindPassword from '../pages/user/login/membership/FindPassword';  // 비밀번호 찾기

//에러
import NetworkError from '../components/error/NetworkError';  // 네크워크 에러


//홈케어
import HomeCareMain from '../pages/user/homecare/HomeCareMain';
import CustomHealth from '../pages/user/homecare/CustomHealth'; //  맞춤질환정보
import HomeTodo from '../pages/user/homecare/HomeTodo'; //  오늘의 할일
import TestCalender from '../pages/user/homecare/calender/TestCalender';  // 캘린더
import PillAdd from '../pages/user/homecare/record/Pill/PillAdd';  // 복약 추가
import PillDetail from '../pages/user/homecare/record/Pill/PillDetail';  // 복약 기록상세
import PillModify from '../pages/user/homecare/record/Pill/PillModify';  // 복약 기록수정
import PillDetailUser from '../pages/user/homecare/record/Pill/PillDetailUser';  // 복약 기록상세(사용자 등록 복약)
import PillAlarm from '../pages/user/homecare/record/Pill/PillAlarm';  // 복약 기록 알림 설정
import HealthAdd from '../pages/user/homecare/record/Health/HealthAdd';  // 건강 기록  추가
import HealthWrite from '../pages/user/homecare/record/Health/HealthWrite';  // 건강 일지 수정
import HealthWriteList from '../pages/user/homecare/record/Health/HealthWriteList';  // 건강 일지 수정 리스트
import HealthDetail from '../pages/user/homecare/record/Health/HealthDetail';  // 건강 기록상세
import HealthAlarm from '../pages/user/homecare/record/Health/HealthAlarm';  // 건강 알림 설정
import EmotionAdd from '../pages/user/homecare/record/Health/EmotionAdd';  // 감정 일지 추가
import EmotionWriteList from '../pages/user/homecare/record/Health/EmotionWriteList';  // 감정 일지 수정 리스트
import EmotionWrite from '../pages/user/homecare/record/Health/EmotionWrite';  // 감정 일지 수정
import BloodPressureRecord from '../pages/user/homecare/record/BloodPressure/BloodPressureRecord';  // 혈압기록
import BloodPressureWrite from '../pages/user/homecare/record/BloodPressure/BloodPressureWrite';  // 혈압기록하기
import BloodSugarRecord from '../pages/user/homecare/record/BloodSugar/BloodSugarRecord';  // 혈당기록
import BloodSugarWrite from '../pages/user/homecare/record/BloodSugar/BloodSugarWrite';  // 혈당기록하기
import BodyMassRecord from '../pages/user/homecare/record/BodyMass/BodyMassRecord';  // 체질량기록
import BodyMassWrite from '../pages/user/homecare/record/BodyMass/BodyMassWrite';  // 체질량기록하기
import StepsMain from '../pages/user/homecare/record/Steps/StepsMain';  // 걸음수 기록 메인
import StepsDashboard from '../pages/user/homecare/record/Steps/StepsDashboard';  // 걸음수 대시보드
import StepsRecordList from '../pages/user/homecare/record/Steps/StepsRecordList';  // 걸음수 기록 리스트

import DiseaseSetting from '../pages/user/homecare/diseaseinfo/DiseaseSetting';  // 질환 설정
import NoticeBoradMovieDetail from '../pages/user/homecare/diseaseinfo/NoticeBoradMovieDetail';  // 동영상 게시판 상세 페이지
import NoticeBoradCardDetail from '../pages/user/homecare/diseaseinfo/NoticeBoradCardDetail';  // 카드뉴스 게시판 상세 페이지
import NoticeBoradSlideDetail from '../pages/user/homecare/diseaseinfo/NoticeBoradSlideDetail';  // 슬라이드 뉴스 게시판 상세 페이지
import NoticeBoradPdfDetail from '../pages/user/homecare/diseaseinfo/NoticeBoradPdfDetail';  // PDF 게시판 상세 페이지

import CustomHealthCardDetail from '../pages/user/homecare/diseaseinfo/CustomHealthCardDetail';  // 맞춤질환 카드뉴스 게시판 상세 페이지
import CustomHealthSlideDetail from '../pages/user/homecare/diseaseinfo/CustomHealthSlideDetail';  // 맞춤질환 슬라이드 게시판 상세 페이지
import CustomHealthMovieDetail from '../pages/user/homecare/diseaseinfo/CustomHealthMovieDetail';  // 맞춤질환 비디오 게시판 상세 페이지

import PreQuestionMain from '../pages/user/homecare/record/PreQuestion/PreQuestionMain';  // 사전 설문지 메인
import PreQuestion from '../pages/user/homecare/record/PreQuestion/PreQuestion';  // 사전 설문지

//설문
import Survey_01 from '../pages/user/homecare/survey/01/Survey_01';  // 설문지01 - 전반적인 활동 상태 설문지
import Survey_02 from '../pages/user/homecare/survey/02/Survey_02';  // 설문지02 - 동반 질환 확인 설문
import Survey_03 from '../pages/user/homecare/survey/03/Survey_03';  // 설문지03 - 일상생활 동작 수행 능력 평가
import Survey_04 from '../pages/user/homecare/survey/04/Survey_04';  // 설문지04 - 집안일 및 외부 활동 수행 능력 설문지
import Survey_05 from '../pages/user/homecare/survey/05/Survey_05';  // 설문지05 - 기억력 및 인지기능 자가진단 설문
import Survey_06 from '../pages/user/homecare/survey/06/Survey_06';  // 설문지06 - 기분 상태 및 스트레스 자가진단 설문 -
import Survey_07 from '../pages/user/homecare/survey/07/Survey_07';  // 설문지07 - 최근 삶의 질 평가 설문
import Survey_08 from '../pages/user/homecare/survey/08/Survey_08';  // 설문지08 - 숙주반응 자가 평가
import Survey_09 from '../pages/user/homecare/survey/09/Survey_09';  // 설문지09 - 최근 삶의의 질 평가 설문 (신체적, 정서적 상태 및 증상 경험 등을 종합적으로 파악하여 환자 중심의 치료와 지지적 간호에 반영하기 위한 설문입니다.)
import Survey_10 from '../pages/user/homecare/survey/10/Survey_10';  // 설문지10 - 손발 저림, 감각이상 증상 체크 설문지
import Survey_11 from '../pages/user/homecare/survey/11/Survey_11';  // 설문지11 - FACT_BMT (조혈모세포이식 환자 삶의 질 평가)
import Survey_15 from '../pages/user/homecare/survey/15/Survey_15';  // 설문지15 - 만성 이식합병증 증상 평가 설문
import Survey_16 from '../pages/user/homecare/survey/16/Survey_16';  // 설문지16 - 당뇨병성 신경병증 관련 설문 (은평 성모/내분비내과)
import Survey_17 from '../pages/user/homecare/survey/17/Survey_17';  // 설문지17 - 당뇨병 위험도 점검 (은평 성모/내분비내과)
import Survey_18 from '../pages/user/homecare/survey/18/Survey_18';  // 설문지18 - 당뇨병성 신경병증 관련 설문 (은평 성모/신장내과)
import Survey_19 from '../pages/user/homecare/survey/19/Survey_19';  // 설문지19 - 당뇨병 위험도 점검 (은평 성모/신장내과)
import Survey_20 from '../pages/user/homecare/survey/20/Survey_20';  // 설문지20 - 당뇨병성 신경병증 관련 설문 (은평 성모/순환기내과)
import Survey_21 from '../pages/user/homecare/survey/21/Survey_21';  // 설문지21 - 당뇨병 위험도 점검 (은평 성모/순환기내과)
import Survey_22 from '../pages/user/homecare/survey/22/Survey_22';  // 설문지22 - 당뇨병성 신경병증 관련 설문 (은평 성모/이비인후과)
import Survey_23 from '../pages/user/homecare/survey/23/Survey_23';  // 설문지23 - 당뇨병 위험도 점검 (은평 성모/이비인후과)

import Survey_24 from '../pages/user/homecare/survey/24/Survey_24';  // 설문지24 - 단백질식단 섭취 설문 (은평 성모/신장내과)
import Survey_25 from '../pages/user/homecare/survey/25/Survey_25';  // 설문지25 - 이명 설문 (은평 성모/이비인후과)
import Survey_26 from '../pages/user/homecare/survey/26/Survey_26';  // 설문지26 - 이명 장애 척도 설문 (은평 성모/이비인후과)
import Survey_27 from '../pages/user/homecare/survey/27/Survey_27';  // 설문지27 - 어지럼증 설문 (은평 성모/이비인후과)
import Survey_28 from '../pages/user/homecare/survey/28/Survey_28';  // 설문지28 - 어지럼증 설문 (은평 성모/이비인후과)

import SurveyCustom from '../pages/user/homecare/survey/custom/SurveyCustom';  // 맞춤 설문지



//병원케어
import HospitalCare from '../pages/user/hospitalcare/HospitalCare';
import MedicalHistory from '../pages/user/hospitalcare/history/MedicalHistory'; // 진료내역
import MedicalReservationHistory from '../pages/user/hospitalcare/history/MedicalReservationHistory'; // 진료 예약내역
import PrescriptionHistory from '../pages/user/hospitalcare/history/PrescriptionHistory'; // 처방내역
import InspectionHistory from '../pages/user/hospitalcare/history/InspectionHistory'; // 검사내역

import MedicalDetails from '../pages/user/hospitalcare/details/MedicalDetails'; // 진료내역 상세
import MedicalOutDetails from '../pages/user/hospitalcare/details/MedicalOutDetails'; // 진료내역 상세 (비대면)
import PayMedicalExpenses from '../pages/user/hospitalcare/details/PayMedicalExpenses'; // 진료내역 상세 > 진료비 수납하기

import MedicalReservationInDetails from '../pages/user/hospitalcare/details/MedicalReservationInDetails'; // 진료 예약 상세 (외래)
import MedicalReservationOutDetails from '../pages/user/hospitalcare/details/MedicalReservationOutDetails'; // 진료 예약상세 (비대면)
import NonContactMedicalCover from '../pages/user/hospitalcare/details/NonContactMedicalCover'; // 진료 예약상세 (비대면) > 진료실 입장 > 커버 화면 (입장하기 / 닫기 )

import PrescriptionDetail from '../pages/user/hospitalcare/details/PrescriptionDetail'; // 처방내역 상세
import InspectionDetail from '../pages/user/hospitalcare/details/InspectionDetail'; // 검사내역 상세
import PrescriptionCheck from '../pages/user/hospitalcare/details/PrescriptionCheck'; // 처방전 확인하기
import PharmacyFind from '../pages/user/hospitalcare/details/PharmacyFind'; // 처방전 확인하기 > 근처 약국 찾기

import HospitalInformation from '../pages/user/hospitalcare/helpinfo/hospital/HospitalInformation'; //병원정보
import DepartmentInform from '../pages/user/hospitalcare/helpinfo/hospital/DepartmentInform'; //진료과/의료진 안내
import DepartmentDetail from '../pages/user/hospitalcare/helpinfo/hospital/DepartmentDetail'; //진료과/의료진 상세
import DoctorDetail from '../pages/user/hospitalcare/helpinfo/hospital/DoctorDetail'; //의료진 상세
import LocationInfo from '../pages/user/hospitalcare/helpinfo/hospital/LocationInfo'; // 진료실/검사실 위치 안내
//import LocationImageView from '../pages/user/hospitalcare/helpinfo/hospital/LocationImageView'; // 진료실/검사실 위치 이미지 뷰뷰
import PhoneNumInfo from '../pages/user/hospitalcare/helpinfo/hospital/PhoneNumInfo'; //주요 전화번호 안내
import Amenity from '../pages/user/hospitalcare/helpinfo/Amenity';  // 편의시설
import Directions from '../pages/user/hospitalcare/helpinfo/Directions';  //오시는 길
import Parking from '../pages/user/hospitalcare/helpinfo/Parking';  // 주차 안내
import ParentalSettings from '../pages/user/hospitalcare/helpinfo/ParentalSettings';  // 가족/보호자 설정
import ParentalRegister from '../pages/user/hospitalcare/helpinfo/ParentalRegister';  // 가족/보호자 등록록

import NoticeLists from '../pages/user/hospitalcare/notice/NoticeLists';  // 공지사항 리스트
import NoticeDetail from '../pages/user/hospitalcare/notice/NoticeDetail';  // 공지사항 상세
import FAQLists from '../pages/user/hospitalcare/faq/FAQLists';  // 자주 찾는 질문 리스트


//알림
import Alarm from '../pages/user/alarm/Alarm';

//내정보
import MyPageMain from '../pages/user/mypage/MyPageMain';
import MyDataCollect from '../pages/user/mypage/collect/MyDataCollect';
import MyDataViewSetting from '../pages/user/mypage/data/MyDataViewSetting';  // 화면 설정정

import DiagnosisMore from '../pages/user/mypage/data/more/DiagnosisMore';  // 주요 진단 더보기
import SurgeryMore from '../pages/user/mypage/data/more/SurgeryMore';  // 주요 수술/처치력 더보기
import MedicationMore from '../pages/user/mypage/data/more/MedicationMore';  // 주요 약물 더보기
import InspectionMore from '../pages/user/mypage/data/more/InspectionMore';  // 주요 검사결과 더보기
import DoctorMore from '../pages/user/mypage/data/more/DoctorMore';  // 주치의 더보기

import BasicInfoWrite from '../pages/user/mypage/data/write/BasicInfoWrite';  // 기본정보 수정
import AllergyListWrite from '../pages/user/mypage/data/write/AllergyListWrite';  // 알레르기 수정
import PastHistoryWrite from '../pages/user/mypage/data/write/PastHistoryWrite';  // 과거력 수정
import FamilyHistoryWrite from '../pages/user/mypage/data/write/FamilyHistoryWrite';  // 가족력 수정
import DrugsListWrite from '../pages/user/mypage/data/write/DrugsListWrite';  // 현재 복용중인 약물 수정

import InspectionTotalDetail from '../pages/user/mypage/data/more/InspectionTotalDetail';  // //내정보-상세정보-전체-검사상세 페이지 공통 사용불가로 페이지 생성


//전체메뉴
import TotalMenu from '../pages/user/totalmenu/TotalMenu';

//전체메뉴 > 앱설정
import AppSettings from '../pages/user/totalmenu/appsetting/AppSettings';  // 앱 설정
import MyInfoWrite from '../pages/user/totalmenu/appsetting/MyInfoWrite';  // 앱 설정 > 내 정보 수정
import ChangePassword from '../pages/user/totalmenu/appsetting/ChangePassword';  // 앱 설정 > 내 정보 수정 > 비밀번호 변경
import MyInfoWithdraw from '../pages/user/totalmenu/appsetting/MyInfoWithdraw';  // 앱 설정 > 내 정보 수정 > 탈퇴하기
import AppAlarmSetting from '../pages/user/totalmenu/appsetting/AppAlarmSetting';  // 앱 설정 > 앱 알림 설정
import CustomDiseaseSetting from '../pages/user/totalmenu/appsetting/CustomDiseaseSetting';  // 앱 설정 > 맞춤 질환 정보 설정
import MyHospitalSetting from '../pages/user/totalmenu/appsetting/MyHospitalSetting';  // 앱 설정 > 내 병원 설정
import MyHospitalDisconnect from '../pages/user/totalmenu/appsetting/MyHospitalDisconnect';  // 앱 설정 > 내 병원 설정 > 병원 연결 해제
import MyHospitalConnection from '../pages/user/totalmenu/appsetting/MyHospitalConnection';  // 앱 설정 > 내 병원 설정 > 병원 연결
import MyHospitalLink from '../pages/user/totalmenu/appsetting/MyHospitalLink';  // 앱 설정 > 내 병원 설정 > 병원 연결 > 병원 환자번호 연동
import MainHospitalSetting from '../pages/user/totalmenu/appsetting/MainHospitalSetting';  // 앱 설정 > 내 병원 설정 > 대표 병원 설정
import HospitalOrderSetting from '../pages/user/totalmenu/appsetting/HospitalOrderSetting';  // 앱 설정 > 내 병원 설정 > 병원 순서 변경
import RecordSetting from '../pages/user/totalmenu/appsetting/RecordSetting';  // 앱 설정 > 기록설정
import RecordSettingDetail from '../pages/user/totalmenu/appsetting/RecordSettingDetail';  // 앱 설정 > 기록설정 > 기록설정 상세
import ServiceNotice from '../pages/user/totalmenu/appsetting/ServiceNotice';  // 앱 설정 > 서비스 공지사항
import ServiceNoticeDetail from '../pages/user/totalmenu/appsetting/ServiceNoticeDetail';  // 앱 설정 > 서비스 공지사항 > 상세보기
import ServiceUseGuide from '../pages/user/totalmenu/appsetting/ServiceUseGuide';  // 앱 설정 > 서비스 이용 가이드
import ServiceUseGuideDetail from '../pages/user/totalmenu/appsetting/ServiceUseGuideDetail';  // 앱 설정 > 서비스 이용 가이드 > 상세보기
import ServiceFaqLists from '../pages/user/totalmenu/appsetting/ServiceFaqLists';  // 앱 설정 > 자주하는 질문
import ServicePolicy from '../pages/user/totalmenu/appsetting/ServicePolicy';  // 앱 설정 > 서비스 약관 및 정책
import ServicePolicyDetail from '../pages/user/totalmenu/appsetting/ServicePolicyDetail';  // 앱 설정 > 서비스 약관 및 정책 > 상세보기
import AppVersion from '../pages/user/totalmenu/appsetting/AppVersion';  // 앱 설정 > 앱 버전 정보
import ErrorReport from '../pages/user/totalmenu/appsetting/ErrorReport';  // 앱 설정 > 오류 제보
import AccessibilitySetting from '../pages/user/totalmenu/appsetting/AccessibilitySetting';  // 앱 설정 > 고대비 설정
import BusinessInform from '../pages/user/totalmenu/appsetting/BusinessInform';  // 앱 설정 > 사업자 정보


//채팅
import ServiceChat from '../pages/user/chatbot/ServiceChat';   // 서비스 이용안내
import NutritionChat from '../pages/user/chatbot/NutritionChat';  // 영양상담


import { AnimatePresence } from 'framer-motion';
import PageError from '../components/comm/PageError';
import ProtectedRoute from './ProtectedRoute';

//결제
import PaymentRegister from '../pages/user/payment/PaymentRegister';
import PayResult from '../pages/user/payment/PayResult';

//비대면
import NonFaceLoginMain from '../pages/user/contactless/login/NonFaceLoginMain';   // 비대면 로그인 메인
import NonFaceSignUp from '../pages/user/contactless/login/NonFaceSignUp';   // 비대면 회원가입
import NonFaceAgreeConditions from '../pages/user/contactless/login/NonFaceAgreeConditions';   // 비대면 약관
import NonFaceFindId from '../pages/user/contactless/login/NonFaceFindId';   // 비대면 아이디 찾기
import NonFaceFindPassword from '../pages/user/contactless/login/NonFaceFindPassword';   // 비대면 비밀번호 찾기
import NonFaceChangePassword from '../pages/user/contactless/login/NonFaceChangePassword';   // 비대면 비밀번호 변경
import NonFaceComplete from '../pages/user/contactless/login/NonFaceComplete';   // 비대면 완료페이지
import NonFaceWithdraw from '../pages/user/contactless/login/NonFaceWithdraw';   // 비대면 탈퇴페이지

import ContactlessMain from '../pages/user/contactless/ContactlessMain';   // 비대면 메인
import ContactlessDetail from '../pages/user/contactless/ContactlessDetail';   // 비대면 상세페이지
import ContactlessSetting from '../pages/user/contactless/ContactlessSetting';   // 비대면 setting 화면
import ContactlessEdit from '../pages/user/contactless/ContactlessEdit';   // 비대면 edit 화면
import ContactlessNotifi from '../pages/user/contactless/ContactlessNotifi';   // 비대면 알림 화면
import HospitalLinkage from '../pages/user/contactless/HospitalLinkage';   // 비대면 병원 연동 화면
import FileUpload from '../pages/user/contactless/FileUpload';   // 비대면 파일 업로드


import KakaoRedirectPage from '../pages/user/login/callback/KakaoRedirectPage';
import NaverRedirectPage from '../pages/user/login/callback/NaverRedirectPage';
import NiceRedirectPage from '../pages/user/login/callback/NiceRedirectPage';
import GoogleRedirectPage from '../pages/user/login/callback/GoogleRedirectPage';
import AppleRedirectPage from '../pages/user/login/callback/AppleRedirectPage';
import { processLogin } from '../assets/js/comm';
import ApkDownload from '../pages/user/util/ApkDownload';
import TTSSetting from '../pages/user/totalmenu/appsetting/TTSSetting';
import getScreenNameKorean from '../pages/user/util/getScreenNameKorean';




const RootRoutes = () => {

    const user = sessionStorage.getItem("loginUser");
    //useLocation객체를 이용하여 정규표현식을 사용한 /admin/~ 으로 시작하는 경로와 비교에 사용(아래 1줄) */}
    const location = useLocation();
    const navigate = useNavigate();

    //리액트에서 사이트관리자에 접근하는 토큰값 위변조 방지용으로 서버에서 비교하는 함수 추가
    const jwtAuthentication = useCallback(() => {
        console.group('jwtAuthentication');
        console.log('[Start] jwtAuthentication ------------------------------');

        const jwtAuthURL = '/signup/jwtAuthAPI';
        const jToken = localStorage.getItem('jToken');
        let requestOptions = {
            method: 'POST',
            headers: {
                Authorization: jToken,
            },
        };

        axiosApi.post(jwtAuthURL, requestOptions, (resp) => {
            console.log(' ==============> jwtAuthentication resp : ', resp);

            if (resp === false) {
                setMounted(false);
            } else {
                setMounted(true); // 이 값으로 true 일 때만 페이지를 렌더링이 되는 변수 사용.
            }
        });

        console.log('------------------------------jwtAuthentication [End]');
        console.groupEnd('jwtAuthentication');
    }, []);

    /* 인프라구성에 맞지않아 사용할수 없음.
    const sessionAuthentication = useCallback( () => {
        console.group('sessionAuthentication');
        console.log('[Start] sessionAuthentication ------------------------------');

        const sessionAuthURL = '/signup/sessionExtension';

        axiosApi.post(sessionAuthURL,(resp) => {
            console.log(' ==============> sessionAuthentication resp : ', resp);

            if (resp === false) {
                setMounted(false);
            } else {
                setMounted(true); // 이 값으로 true 일 때만 페이지를 렌더링이 되는 변수 사용.
            }
        });

        console.log('------------------------------sessionAuthentication [End]');
        console.groupEnd('sessionAuthentication');
    }, []);
    */

    //시스템관리 메뉴인 /admin/으로 시작하는 URL은 모두 로그인이 필요하도록 코드추가(아래)
    const isMounted = useRef(false); // 아래 로그인 이동 부분이 2번 실행되지 않도록 즉, 마운트 될 때만 실행되도록 변수 생성
    const [mounted, setMounted] = useState(false); // 컴포넌트 최초 마운트 후 리렌더링 전 로그인 페이지로 이동하는 조건으로 사용

    useEffect(() => {
        const handleNativeMessage = async (event) => {
            try {
                let data;

                if (typeof event.data === 'string') {
                    data = JSON.parse(event.data);
                } else if (typeof event.data === 'object' && event.data !== null) {
                    data = event.data;
                } else {
                    console.warn('수신된 메시지가 알 수 없는 형식입니다:', event.data);
                    return;
                }

                if (data.type === 'KAKAO_LOGIN_SUCCESS') {
                    const { accessToken } = data.payload;
                    console.log('네이티브로부터 카카오 액세스 토큰 수신:', accessToken);

                    const res = await axiosApi.post("/oauth/kakao", {
                        accessToken: accessToken
                    });

                    console.log('oauth/kakao",  : ', JSON.stringify(res, null, 2));

                    const tokens = res.data.result.tokens;
                    const backendToken = tokens.accessToken;
                    const email = tokens.email;
                    const nickname = tokens.nickname;

                    await processLogin(backendToken, email, nickname, navigate, null);
                }
                else if (data.type === 'KAKAO_LOGIN_FAILURE') {
                    console.error('네이티브 카카오 로그인 실패:', data.error);
                    alert('카카오 로그인에 실패했습니다. 다시 시도해주세요.');
                } 
                //handleNativeMessage 내부 PUSH_NAVIGATE 핸들러
                else if (data.type === 'PUSH_NAVIGATE') {
                    const user = sessionStorage.getItem('loginUser');
                    if (!user) return;

                    const d = data.payload || {};

                    if (data.route === '/RecordSettingDetail') {
                        navigate('/RecordSettingDetail', {
                            state: {
                                paramData: {
                                    hsptlCd: d.hsptlCd,
                                    patntId: d.patntId,
                                    prscrptnDt: d.prscrptnDt,
                                    deptCd: d.deptCd,
                                },
                                item: {
                                    hsptlCd: d.hsptlCd,
                                    hsptlNm: d.hsptlNm || '',
                                    patntId: d.patntId,
                                    deptCd: d.deptCd,
                                    deptNm: d.deptNm || '',
                                    prscrptnDt: d.prscrptnDt,
                                    alrmExprDt: d.alrmExprDt || '',
                                }
                            }
                        });
                    } else {
                        // navigate(data.route);
                        navigate(data.route, { state: data.payload });
                    }
                }
                // ★ 기존 NAVIGATE_TO_PAGE도 처리 (앱이 이미 켜져있을 때)
                else if (data.type === 'NAVIGATE_TO_PAGE') {
                    const user = sessionStorage.getItem('loginUser');
                    if (!user) return;
                    navigate(data.path);
                }

            } catch (err) {
                console.error('네이티브 메시지 처리 또는 백엔드 통신 오류:', err, event.data);

                if (err instanceof SyntaxError) {
                    //  alert('네이티브 메시지 파싱 오류가 발생했습니다. : ', JSON.stringify(err));
                } else {
                    alert('로그인 처리 중 오류가 발생했습니다.');
                    navigate(PATH.LANDING, { replace: true });
                }
            }
        };

        if (window.ReactNativeWebView) {
            document.addEventListener('message', handleNativeMessage); // Android
            window.addEventListener('message', handleNativeMessage);   // iOS
        }

        return () => {
            if (window.ReactNativeWebView) {
                document.removeEventListener('message', handleNativeMessage);
                window.removeEventListener('message', handleNativeMessage);
            }
        };
    }, [navigate]);

    useEffect(() => {

        //sessionAuthentication();

        if (!isMounted.current) {
            // 컴포넌트 최초 마운트 시 페이지 진입 전(렌더링 전) 실행
            isMounted.current = true; // 이 값으로 true 일 때만 페이지를 렌더링이 되는 변수 사용.
            setMounted(true); // 이 값으로 true 일 때만 페이지를 렌더링이 되는 변수 사용.

            /* 제어할 페이지가 있을 경우 사용
            const regex = /^(\/admin\/)+(.)*$/; //정규표현식 사용: /admin/~ 으로 시작하는 경로 모두 포함
            if (regex.test(location.pathname)) {
                setMounted(false); // 이 값으로 true 일 때만 페이지를 렌더링이 되는 변수 사용. 기본은 숨기기
                //jwtAuthentication(); // 이 함수에서 관리자단 인증여부 확인 후 렌더링 처리
                sessionAuthentication();
            }
            */
        }
        /*
        if(user) {
            sessionAuthentication();
        }
        */

    }, [//sessionAuthentication,
        location, mounted, user]); // location 경로와 페이지 마운트상태가 변경 될 때 업데이트 후 리렌더링

    if (mounted) {
        // 인증 없이 시스템관리 URL로 접근할 때 렌더링 되는 것을 방지하는 조건추가.
        return (
            <Routes>
                <Route path={URL.ERROR} element={<PageError />} />
                <Route path="*" element={<SecondRoutes />} />
            </Routes>
        );
    }
};

const SecondRoutes = () => {

    const location = useLocation();

    //useRef객체를 사용하여 페이지 마운트 된 후 ui.js를 로딩 하도록 변경 코드 추가(아래)
    const isMounted = useRef(false); // 아래 로그인 이동 부분이 2번 실행되지 않도록 즉, 마운트 될 때만 실행되도록 변수 생성

    useEffect(() => {
        if (!isMounted.current) {
            // 컴포넌트 최초 마운트 시 페이지 진입 전(렌더링 전) 실행
            isMounted.current = true; // 이 값으로 true 일 때만 페이지를 렌더링이 되는 변수 사용.
        }
    }, []);

    const ScrollToTop = () => {
        const { pathname } = useLocation();

        // useEffect(() => {
        //     window.scrollTo(0, 0);
        // }, [pathname]);

        useEffect(() => {
            if (pathname === "/DiseaseSetting" || pathname === "/MyPageMain" || pathname === "/MyPageMain/summary" || pathname === "/hospitalCare/MedicalHistory" || pathname === "/hospitalCare/PrescriptionDetail" || pathname === "/hospitalCare/InspectionDetail") return; // 예외 처리
            window.scrollTo(0, 0);
        }, [pathname]);

        return null;
    };

    // 라우트 변경 추적
    useEffect(() => {
        if (window.sendRouteToNative) {
            window.sendRouteToNative(location.pathname, location.search);
        }

        const screenNameKr = getScreenNameKorean(location.pathname);

        // if (window.ReactNativeWebView && location.pathname) {

        //     window.ReactNativeWebView?.postMessage(JSON.stringify({
        //         type: 'GA_SCREEN_VIEW',
        //         screenName: `${screenNameKr} (${location.pathname})`
        //     }));
        // }

        document.title = `${screenNameKr} | CMC careplus`

    }, [location.pathname, location.search]);

    return (
        <>
            {/* <Header loginUser={loginVO} onChangeLogin={(user) => setLoginVO(user)} /> */}
            <AnimatePresence mode="wait">
                {/* 페이지 이동 시 최상단으로 이동 */}
                <ScrollToTop />
                <Routes>

                    {/* ================  애프터 케어 :: S ================ */}
                    {/* Main */}
                    <Route path={URL.MAIN} element={<Landing />} />

                    {/* ERROR */}
                    <Route path={URL.ERROR} element={<PageError />} />
                    <Route path={URL.NETWORKERROR} element={<NetworkError />} />

                    {/* SNS 로그인 Redirect 처리 페이지 */}
                    <Route path={URL.KAKAO_REDIRECT} element={<KakaoRedirectPage />} />
                    <Route path={URL.NAVER_REDIRECT} element={<NaverRedirectPage />} />
                    <Route path={URL.GOOGLE_REDIRECT} element={<GoogleRedirectPage />} />
                    <Route path={URL.APPLE_REDIRECT} element={<AppleRedirectPage />} />

                    {/* 나이스 리다이렉트 */}
                    <Route path={URL.NICE_REDIRECT} element={<NiceRedirectPage />} />

                    {/* Login  */}
                    <Route path={URL.ALLOWACCESS} element={<AllowAccess />} />
                    <Route path={URL.LANDING} element={<Landing />} />
                    <Route path={URL.LOGINMAIN} element={<LoginMain />} />
                    <Route path={URL.IDENTITY} element={<Identity />} />
                    <Route path={URL.MOBILEIDENTITY} element={<MobileIdentity />} />
                    <Route path={URL.AGREECONDITIONS} element={<AgreeConditions />} />
                    <Route path={URL.AGREEGUARDIAN} element={<AgreeGuardian />} />
                    <Route path={URL.MEMBERSHIP_COMPLETE} element={<MembershipComplete />} />
                    <Route path={URL.HISTORY_CHECK} element={<HistoryCheck />} />
                    <Route path={URL.HOSPITAL_LINK} element={<HospitalLink />} />
                    <Route path={URL.HOSPITAL_LINK_COMPLETE} element={<HospitalLinkComplete />} />
                    <Route path={URL.SIGNUP} element={<SignUp />} />
                    <Route path={URL.FINDID} element={<FindId />} />
                    <Route path={URL.FINDPASSWORD} element={<FindPassword />} />

                    {/* 결제 */}
                    <Route path={URL.PAYMENT_REGISTER} element={<PaymentRegister />} />
                    <Route path={URL.PAYMENT_RESULT} element={<PayResult />} />

                    <Route element={<ProtectedRoute />}>

                        {/* Home Care */}
                        <Route path={URL.HOME_CARE_MAIN} element={<HomeCareMain />} />
                        <Route path={URL.CUSTOM_HEALTH} element={<CustomHealth />} />
                        <Route path={URL.HOME_TODO} element={<HomeTodo />} />
                        <Route path={URL.PILL_ADD} element={<PillAdd />} />
                        <Route path={URL.PILL_DETAIL} element={<PillDetail />} />
                        <Route path={URL.PILL_MODIFY} element={<PillModify />} />
                        <Route path={URL.PILL_DETAIL_USER} element={<PillDetailUser />} />
                        <Route path={URL.PILL_ALARM} element={<PillAlarm />} />
                        <Route path={URL.HEALTH_ADD} element={<HealthAdd />} />
                        <Route path={URL.HEALTH_WRITE} element={<HealthWrite />} />
                        <Route path={URL.HEALTH_WRITE_LIST} element={<HealthWriteList />} />
                        <Route path={URL.HEALTH_DETAIL} element={<HealthDetail />} />
                        <Route path={URL.HEALTH_ALARM} element={<HealthAlarm />} />
                        <Route path={URL.EMOTION_ADD} element={<EmotionAdd />} />
                        <Route path={URL.EMOTION_WRITE_LIST} element={<EmotionWriteList />} />
                        <Route path={URL.EMOTION_WRITE} element={<EmotionWrite />} />
                        <Route path={URL.BLOOD_PRESSURE_RECORD} element={<BloodPressureRecord />} />
                        <Route path={URL.BLOOD_PRESSURE_WRITE} element={<BloodPressureWrite />} />
                        <Route path={URL.BLOOD_SUGAR_RECORD} element={<BloodSugarRecord />} />
                        <Route path={URL.BLOOD_SUGAR_WRITE} element={<BloodSugarWrite />} />
                        <Route path={URL.BODY_MASS_RECORD} element={<BodyMassRecord />} />
                        <Route path={URL.BODY_MASS_WRITE} element={<BodyMassWrite />} />
                        <Route path={URL.STEPS_MAIN} element={<StepsMain />} />
                        <Route path={URL.STEPS_DASHBOARD} element={<StepsDashboard />} />
                        <Route path={URL.STEPS_RECORD_LIST} element={<StepsRecordList />} />
                        <Route path={URL.DISEASE_SETTING} element={<DiseaseSetting />} />
                        <Route path={URL.NOTICE_BOARD_MOVIE_DETAIL} element={<NoticeBoradMovieDetail />} />
                        <Route path={URL.NOTICE_BOARD_CARD_DETAIL} element={<NoticeBoradCardDetail />} />
                        <Route path={URL.NOTICE_BOARD_SLIDE_DETAIL} element={<NoticeBoradSlideDetail />} />
                        <Route path={URL.NOTICE_BOARD_PDF_DETAIL} element={<NoticeBoradPdfDetail />} />

                        <Route path={URL.CUSTOM_HEALTH_CARD_DETAIL} element={<CustomHealthCardDetail />} />
                        <Route path={URL.CUSTOM_HEALTH_SLIDE_DETAIL} element={<CustomHealthSlideDetail />} />
                        <Route path={URL.CUSTOM_HEALTH_MOVIE_DETAIL} element={<CustomHealthMovieDetail />} />

                        <Route path={URL.CALENDER} element={<TestCalender />} />
                        <Route path={URL.PRE_QUESTION_MAIN} element={<PreQuestionMain />} />
                        <Route path={URL.PRE_QUESTION} element={<PreQuestion />} />

                        {/* 설문지 */}
                        <Route path={URL.SURVEY_01} element={<Survey_01 />} />
                        <Route path={URL.SURVEY_02} element={<Survey_02 />} />
                        <Route path={URL.SURVEY_03} element={<Survey_03 />} />
                        <Route path={URL.SURVEY_04} element={<Survey_04 />} />
                        <Route path={URL.SURVEY_05} element={<Survey_05 />} />
                        <Route path={URL.SURVEY_06} element={<Survey_06 />} />
                        <Route path={URL.SURVEY_07} element={<Survey_07 />} />
                        <Route path={URL.SURVEY_08} element={<Survey_08 />} />
                        <Route path={URL.SURVEY_09} element={<Survey_09 />} />
                        <Route path={URL.SURVEY_10} element={<Survey_10 />} />
                        <Route path={URL.SURVEY_11} element={<Survey_11 />} />
                        <Route path={URL.SURVEY_15} element={<Survey_15 />} />
                        <Route path={URL.SURVEY_16} element={<Survey_16 />} />
                        <Route path={URL.SURVEY_17} element={<Survey_17 />} />
                        {/* 18~ 23 번까지는 16-17 설문 다른진료과 요청으로 생성으로.. 임시방편이 될수도 있음 */}
                        <Route path={URL.SURVEY_18} element={<Survey_18 />} />
                        <Route path={URL.SURVEY_19} element={<Survey_19 />} />
                        <Route path={URL.SURVEY_20} element={<Survey_20 />} />
                        <Route path={URL.SURVEY_21} element={<Survey_21 />} />
                        <Route path={URL.SURVEY_22} element={<Survey_22 />} />
                        <Route path={URL.SURVEY_23} element={<Survey_23 />} />

                        <Route path={URL.SURVEY_24} element={<Survey_24 />} />
                        <Route path={URL.SURVEY_25} element={<Survey_25 />} />
                        <Route path={URL.SURVEY_26} element={<Survey_26 />} />
                        <Route path={URL.SURVEY_27} element={<Survey_27 />} />
                        <Route path={URL.SURVEY_28} element={<Survey_28 />} />

                        <Route path={URL.SURVEY_CUSTOM} element={<SurveyCustom />} />


                        {/* 병원케어 */}
                        <Route path={URL.HOSPITAL_HOME} element={<HospitalCare />} />
                        <Route path={URL.HOSPITAL_MEDICALHISTORY} element={<MedicalHistory />} />
                        <Route path={URL.HOSPITAL_MEDICALRESERVATIONHISTORY} element={<MedicalReservationHistory />} />
                        <Route path={URL.HOSPITAL_PRESCRIPTIONHISTORY} element={<PrescriptionHistory />} />
                        <Route path={URL.HOSPITAL_INSPECTIONHISTORY} element={<InspectionHistory />} />

                        <Route path={URL.HOSPITAL_MEDICALDETAILS} element={<MedicalDetails />} />
                        <Route path={URL.HOSPITAL_MEDICALOUTDETAILS} element={<MedicalOutDetails />} />
                        <Route path={URL.PAY_MEDICAL_EXPENSES} element={<PayMedicalExpenses />} />
                        <Route path={URL.HOSPITAL_MEDICALRESERVATIONDETAILSIN} element={<MedicalReservationInDetails />} />
                        <Route path={URL.HOSPITAL_MEDICALRESERVATIONDETAILSOUT} element={<MedicalReservationOutDetails />} />
                        <Route path={URL.NONCONTACT_MEDICAL_COVER} element={<NonContactMedicalCover />} />
                        <Route path={URL.HOSPITAL_PRESCRIPTIONDETAIL} element={<PrescriptionDetail />} />
                        <Route path={URL.HOSPITAL_INSPECTIONDETAIL} element={<InspectionDetail />} />
                        <Route path={URL.HOSPITAL_PRESCRIPTIONCHECK} element={<PrescriptionCheck />} />
                        <Route path={URL.HOSPITAL_PHARMACYFIND} element={<PharmacyFind />} />

                        <Route path={URL.HOSPITAL_HOSPITALINFORMATION} element={<HospitalInformation />} />
                        <Route path={URL.HOSPITAL_DEPARTMENTINFORM} element={<DepartmentInform />} />
                        <Route path={URL.HOSPITAL_DEPARTMENTDETAIL} element={<DepartmentDetail />} />
                        <Route path={URL.HOSPITAL_DOCTORDETAIL} element={<DoctorDetail />} />
                        <Route path={URL.HOSPITAL_LOCATIONINFO} element={<LocationInfo />} />
                        {/* <Route path={URL.HOSPITAL_LOCATIONIMAGEVIEW} element={<LocationImageView />} /> */}
                        <Route path={URL.HOSPITAL_PHONENUMINFO} element={<PhoneNumInfo />} />
                        <Route path={URL.HOSPITAL_AMENITY} element={<Amenity />} />
                        <Route path={URL.HOSPITAL_DIRECTIONS} element={<Directions />} />
                        <Route path={URL.HOSPITAL_PARKING} element={<Parking />} />
                        <Route path={URL.HOSPITAL_PARENTALSETTINGS} element={<ParentalSettings />} />
                        <Route path={URL.HOSPITAL_PARENTALREGISTER} element={<ParentalRegister />} />

                        <Route path={URL.HOSPITAL_NOTICELISTS} element={<NoticeLists />} />
                        <Route path={URL.HOSPITAL_NOTICEDETAIL} element={<NoticeDetail />} />
                        <Route path={URL.HOSPITAL_FAQLISTS} element={<FAQLists />} />


                        {/* <Route path={URL.HOSPITAL_USERHISTORY} element={<UserMedicHistory />} />
                    <Route path={URL.HOSPITAL_RESERVATIONIN} element={<UserReservationIn />}/>
                    <Route path={URL.HOSPITAL_RESERVATIONOUT} element={<UserReservationOut />} /> */}

                        {/* 알림 */}
                        <Route path={URL.ALARM} element={<Alarm />} />

                        {/* 내정보 */}
                        <Route path={URL.MY_PAGE_MAIN} element={<MyPageMain />} />
                        <Route path={URL.MY_DATA_VIEW_SETTING} element={<MyDataViewSetting />} />
                        <Route path={URL.MY_DATA_COLLECT} element={<MyDataCollect />} />

                        <Route path={URL.DIAGNOSIS_MORE} element={<DiagnosisMore />} />
                        <Route path={URL.SURGERY_MORE} element={<SurgeryMore />} />
                        <Route path={URL.MEDICATION_MORE} element={<MedicationMore />} />
                        <Route path={URL.INSPECTION_MORE} element={<InspectionMore />} />
                        <Route path={URL.DOCTOR_MORE} element={<DoctorMore />} />

                        <Route path={URL.BASIC_INFO_WRITE} element={<BasicInfoWrite />} />
                        <Route path={URL.ALLERGY_LIST_WRITE} element={<AllergyListWrite />} />
                        <Route path={URL.PAST_HISTORY_WRITE} element={<PastHistoryWrite />} />
                        <Route path={URL.FAMILY_HISTORY_WRITE} element={<FamilyHistoryWrite />} />
                        <Route path={URL.DRUGS_LIST_WRITE} element={<DrugsListWrite />} />
                        <Route path={URL.INSPECTION_TOTAL_DETAIL} element={<InspectionTotalDetail />} />


                        {/* 전체메뉴 */}
                        <Route path={URL.TOTAL_MENU} element={<TotalMenu />} />

                        {/* 전체메뉴 > 앱설정 */}
                        <Route path={URL.APP_SETTINGS} element={<AppSettings />} />
                        <Route path={URL.MYINFO_WRITE} element={<MyInfoWrite />} />
                        <Route path={URL.CHANGE_PASSWORD} element={<ChangePassword />} />
                        <Route path={URL.MY_INFO_WITHDRAW} element={<MyInfoWithdraw />} />
                        <Route path={URL.APP_ALARM_SETTING} element={<AppAlarmSetting />} />
                        <Route path={URL.CUSTOM_DISEASE_SETTING} element={<CustomDiseaseSetting />} />
                        <Route path={URL.MY_HOSPITAL_SETTING} element={<MyHospitalSetting />} />
                        <Route path={URL.MY_HOSPITAL_DISCONNECT} element={<MyHospitalDisconnect />} />
                        <Route path={URL.MY_HOSPITAL_CONNECTION} element={<MyHospitalConnection />} />
                        <Route path={URL.MY_HOSPITAL_LINK} element={<MyHospitalLink />} />
                        <Route path={URL.MAIN_HOSPITAL_SETTING} element={<MainHospitalSetting />} />
                        <Route path={URL.HOSPITAL_ORDER_SETTING} element={<HospitalOrderSetting />} />
                        <Route path={URL.RECORD_SETTING} element={<RecordSetting />} />
                        <Route path={URL.RECORD_SETTING_DETAIL} element={<RecordSettingDetail />} />
                        <Route path={URL.SERVICE_NOTICE} element={<ServiceNotice />} />
                        <Route path={URL.SERVICE_NOTICE_DETAIL} element={<ServiceNoticeDetail />} />
                        <Route path={URL.SERVICE_USE_GUIDE} element={<ServiceUseGuide />} />
                        <Route path={URL.SERVICE_USE_GUIDE_DETAIL} element={<ServiceUseGuideDetail />} />
                        <Route path={URL.SERVICE_FAQ_LISTS} element={<ServiceFaqLists />} />
                        <Route path={URL.SERVICE_POLICY} element={<ServicePolicy />} />
                        <Route path={URL.SERVICE_POLICY_DETAIL} element={<ServicePolicyDetail />} />
                        <Route path={URL.APP_VERSION} element={<AppVersion />} />
                        <Route path={URL.ERROR_REPORT} element={<ErrorReport />} />
                        <Route path={URL.ACCESSIBILITY_SETTING} element={<AccessibilitySetting />} />
                        <Route path={URL.BUSINESS_INFORM} element={<BusinessInform />} />

                        <Route path="/AppSettings/tts" element={<TTSSetting />} />

                        {/* Chat */}
                        <Route path={URL.SERVICE_CHAT} element={<ServiceChat />} />
                        <Route path={URL.NUTRITION_CHAT} element={<NutritionChat />} />

                    </Route>


                    {/* 비대면 */}
                    <Route path={URL.NONFACE_LOGIN_MAIN} element={<NonFaceLoginMain />} />
                    <Route path={URL.NONFACE_SIGNUP} element={<NonFaceSignUp />} />
                    <Route path={URL.NONFACE_AGREE_CONDITIONS} element={<NonFaceAgreeConditions />} />
                    <Route path={URL.NONFACE_FINDID} element={<NonFaceFindId />} />
                    <Route path={URL.NONFACE_FINDPASSWORD} element={<NonFaceFindPassword />} />
                    <Route path={URL.NONFACE_CHANGEPASSWORD} element={<NonFaceChangePassword />} />
                    <Route path={URL.NONFACE_COMPLETE} element={<NonFaceComplete />} />
                    <Route path={URL.NONFACE_WITHDRAW} element={<NonFaceWithdraw />} />

                    <Route path={URL.CONTACTLESS_MAIN} element={<ContactlessMain />} />
                    <Route path={URL.CONTACTLESS_DETAIL} element={<ContactlessDetail />} />
                    <Route path={URL.CONTACTLESS_SETTING} element={<ContactlessSetting />} />
                    <Route path={URL.CONTACTLESS_EDIT} element={<ContactlessEdit />} />
                    <Route path={URL.CONTACTLESS_NOTI} element={<ContactlessNotifi />} />
                    <Route path={URL.HOSPITAL_LINKAGE} element={<HospitalLinkage />} />
                    <Route path={URL.FILE_UPLOAD} element={<FileUpload />} />


                    {/* ================  애프터 케어 :: E ================ */}



                    {/* apk 다운 전용링크 */}
                    <Route path={URL.APK_DOWNLOAD} element={<ApkDownload />} />
                </Routes>
            </AnimatePresence>
            {/* <Footer /> */}
        </>
    );
};

export default RootRoutes;
